import React from "react";
import { getNewChatAvatarSrc } from "../utils";

export default function NewChatListItem({ item, userData, onSelect }) {
  return (
    <div
      onClick={() => onSelect(item)}
      className={`messaging__chats-item ${
        item?.id === userData?.id ? "messaging__chats-item_active" : ""
      }`}
    >
      <div className="messaging__item-left">
        <div className="messaging__item-avatar">
          <img src={getNewChatAvatarSrc(item)} alt="avatar" />
        </div>
        <div className="messaging__item-info">
          <p className="messaging__item-name">{item?.technician_name}</p>
          {item?.type !== "support" && (
            <div className="messaging__item-id">Job ID# {item?.id}</div>
          )}
        </div>
      </div>
    </div>
  );
}
